import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { register as registerApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await registerApi({ name, email, password });
      login(response.data.token, response.data.user);
      toast.success('Účet vytvořen');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Chyba při registraci');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <h1 className="font-oswald text-4xl font-bold uppercase tracking-tight mb-2">
              Registrace
            </h1>
            <p className="font-serif text-gray-600">
              Vytvořte si účet pro přístup do systému
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="name" className="font-oswald uppercase text-xs tracking-wide">
                Jméno
              </Label>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Jan Novák"
                required
                className="border-2 border-gray-200 focus:border-black rounded-none font-serif"
                data-testid="register-name"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="email" className="font-oswald uppercase text-xs tracking-wide">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vas@email.cz"
                required
                className="border-2 border-gray-200 focus:border-black rounded-none font-serif"
                data-testid="register-email"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="font-oswald uppercase text-xs tracking-wide">
                Heslo
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                minLength={6}
                className="border-2 border-gray-200 focus:border-black rounded-none font-serif"
                data-testid="register-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#F4E600] text-black font-oswald uppercase tracking-wide border-2 border-black rounded-none shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] transition-all"
              data-testid="register-submit"
            >
              {loading ? 'Vytváření účtu...' : 'Vytvořit účet'}
            </Button>
          </form>

          <p className="mt-6 text-center font-serif text-gray-600">
            Již máte účet?{' '}
            <Link
              to="/login"
              className="font-oswald uppercase text-sm text-[#006CB6] hover:underline"
              data-testid="login-link"
            >
              Přihlásit se
            </Link>
          </p>
        </div>
      </div>

      {/* Right side - Image */}
      <div className="hidden lg:block lg:flex-1 bg-black relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#F4E600] to-black opacity-90" />
        <div className="absolute inset-0 flex items-center justify-center p-12">
          <div className="text-center">
            <div className="font-oswald text-6xl font-bold text-black uppercase tracking-tight mb-4">
              Připojte se
            </div>
            <div className="font-oswald text-6xl font-bold text-white uppercase tracking-tight mb-4">
              k týmu
            </div>
            <div className="font-serif text-xl text-gray-300 max-w-md mx-auto">
              První registrovaný uživatel se stane administrátorem
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
